var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityManagerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Security_Manager_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security_Manager_Active",
    "data-name": "Security Manager_Active",
    clipPath: "url(#clip-Security_Manager_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Permission_Roles",
    "data-name": "Permission Roles",
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_45",
    "data-name": "Subtraction 45",
    d: "M-1403.164-582.483h-20.246a1.592,1.592,0,0,1-1.589-1.59V-600.41a1.592,1.592,0,0,1,1.589-1.59h20.246a1.592,1.592,0,0,1,1.589,1.59v16.337A1.592,1.592,0,0,1-1403.164-582.483Zm-10.123-15.61a6.13,6.13,0,0,0-6.269,5.964,6.13,6.13,0,0,0,6.269,5.964,6.13,6.13,0,0,0,6.269-5.964A6.13,6.13,0,0,0-1413.287-598.093Z",
    transform: "translate(1425.727 611.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    transform: "translate(0 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4742",
    "data-name": "Path 4742",
    d: "M29.78,33.416H12.959A4.013,4.013,0,0,1,8.93,29.441V16.405a4.013,4.013,0,0,1,4.029-3.975H29.78a4.013,4.013,0,0,1,4.029,3.975.7.7,0,0,1-1.408,0,2.611,2.611,0,0,0-2.622-2.586H12.959a2.611,2.611,0,0,0-2.622,2.586V29.441a2.611,2.611,0,0,0,2.622,2.586H29.78A2.611,2.611,0,0,0,32.4,29.441V21.283a.7.7,0,0,1,1.408,0v8.158A4.013,4.013,0,0,1,29.78,33.416Z",
    transform: "translate(-8.93 -12.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4743",
    "data-name": "Path 4743",
    d: "M23,17.218a.729.729,0,0,1-.727-.727v-.055a.727.727,0,1,1,1.454,0v.055A.729.729,0,0,1,23,17.218Z",
    transform: "translate(1.156 -10.036)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    "data-name": "Path 4744",
    d: "M13.141,17.792a.707.707,0,0,1-.681-.727V13.921A6.259,6.259,0,0,1,18.5,7.47a6.259,6.259,0,0,1,6.043,6.451.682.682,0,1,1-1.362,0A4.837,4.837,0,0,0,18.52,8.942a4.837,4.837,0,0,0-4.664,4.979v3.144a.707.707,0,0,1-.681.727Z",
    transform: "translate(-6.045 -7.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_49",
    "data-name": "Subtraction 49",
    d: "M-1673.406-593.823h-1.042a.492.492,0,0,1-.488-.457l-.024-.39a3.134,3.134,0,0,1-.512-.213l-.3.256a.5.5,0,0,1-.323.116.483.483,0,0,1-.347-.146l-.737-.738a.492.492,0,0,1-.024-.67l.256-.293a3.424,3.424,0,0,1-.213-.518l-.39-.03a.5.5,0,0,1-.451-.494v-1.043a.492.492,0,0,1,.457-.488l.39-.024a3.134,3.134,0,0,1,.213-.512l-.256-.3a.493.493,0,0,1,.025-.671l.737-.738a.507.507,0,0,1,.347-.14.5.5,0,0,1,.323.122l.292.256a3.414,3.414,0,0,1,.518-.213l.03-.39a.486.486,0,0,1,.487-.457l.006.006h1.042a.492.492,0,0,1,.488.457l.024.39a3.123,3.123,0,0,1,.512.213l.3-.256a.5.5,0,0,1,.323-.116.483.483,0,0,1,.347.147l.737.738a.493.493,0,0,1,.024.671l-.256.293a3.416,3.416,0,0,1,.213.518l.39.03a.5.5,0,0,1,.451.494v1.043a.492.492,0,0,1-.457.488l-.39.025a3.132,3.132,0,0,1-.213.512l.256.3a.493.493,0,0,1-.024.671l-.372.366-.372.366a.5.5,0,0,1-.347.14.493.493,0,0,1-.323-.122l-.293-.256a3.4,3.4,0,0,1-.518.213l-.03.39A.486.486,0,0,1-1673.406-593.823Zm-.525-5.9a1.8,1.8,0,0,0-1.267.524,1.794,1.794,0,0,0-.53,1.274,1.788,1.788,0,0,0,.524,1.274,1.788,1.788,0,0,0,1.273.531h.006a1.8,1.8,0,0,0,1.267-.525,1.793,1.793,0,0,0,.53-1.274,1.792,1.792,0,0,0-.524-1.275,1.791,1.791,0,0,0-1.273-.53Z",
    transform: "translate(1686.376 617.426)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityManagerActive);
export default __webpack_public_path__ + "static/media/Security_Manager_Active.95b58acded21b358c75f554403d4f846.svg";
export { ForwardRef as ReactComponent };